<template>
    <section class="w-full">
        <h2 v-if="hasItems" class="text-xl font-semibold mb-5">{{ heading }}</h2>

        <!-- есть данные -->
        <div v-if="hasItems" class="grid grid-cols-1 md:grid-cols-2 gap-x-5 md:gap-x-8 gap-y-5">
            <article
                v-for="(faq, idx) in visibleFaqs"
                :key="idx"
                class="w-full border-b border-gray-200 pb-3"
            >
                <h3 class="text-lg font-medium mb-3">
                    {{ idx + 1 }}. {{ faq.title }}
                </h3>
                <div class="text-sm text-gray-700 space-y-2">
                    <p v-for="(line, i) in faq.answer" :key="i">
                        {{ line }}
                    </p>
                </div>
            </article>
        </div>

        <!-- пусто -->
        <div v-else class="text-sm text-gray-600 italic">
            {{ emptyText }}
        </div>
    </section>
</template>

<script setup>
import { computed, onMounted, onBeforeUnmount, watch } from 'vue'

defineOptions({ name: 'ProductFaq' })

const props = defineProps({
    // [{ title: string, text: string|string[] }]
    items: { type: Array, required: true, default: () => [] },
    heading: { type: String, default: 'Частые вопросы' },
    emptyText: { type: String, default: 'FAQ пока пустой' },
})

// нормализация: text → массив абзацев
const normalizedFaqs = computed(() =>
    (props.items || []).map((it) => {
        const title = String(it?.title ?? '').trim()
        const text = it?.text ?? ''
        const answer = Array.isArray(text)
            ? text.map(s => String(s ?? '').trim()).filter(Boolean)
            : String(text)
                .split(/\r?\n\r?\n|\r?\n/g)
                .map(s => s.trim())
                .filter(Boolean)
        return { title, answer }
    })
)

// показываем только заполненные QA
const visibleFaqs = computed(() =>
    normalizedFaqs.value.filter(f => f.title && f.answer.length)
)

const hasItems = computed(() => visibleFaqs.value.length > 0)
</script>
